/**
 * Preferencias del workshop (velocidad, subtítulos, cursor, voz, música),
 * recordadas por persona en localStorage. Conveniencia, no estado: si el
 * navegador no deja guardar, se usan los defaults y listo.
 */
import { useCallback, useState } from 'react';
import type { WorkshopSettings } from './types';

const KEY = 'vault.workshop.settings';

export const DEFAULT_SETTINGS: WorkshopSettings = { speed: 1, subtitles: true, cursor: true, voice: true, music: true };

function read(): WorkshopSettings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_SETTINGS;
    const parsed = JSON.parse(raw) as Partial<WorkshopSettings>;
    const speed = parsed.speed === 1.25 || parsed.speed === 1.5 ? parsed.speed : 1;
    return { ...DEFAULT_SETTINGS, ...parsed, speed };
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function useWorkshopSettings() {
  const [settings, setSettings] = useState<WorkshopSettings>(read);
  const update = useCallback((patch: Partial<WorkshopSettings>) => {
    setSettings((prev) => {
      const next = { ...prev, ...patch };
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        // modo privado: no se recuerda, no pasa nada
      }
      return next;
    });
  }, []);
  return [settings, update] as const;
}
